import Box from "@mui/material/Box"
import Chip from "@mui/material/Chip"
import Typography from "@mui/material/Typography"
import { useTheme } from "@mui/material/styles"

import { recruitProfileDisplayFieldSx } from "./recruitProfileSectionStyles"

export const RECRUIT_PROFILE_UNSET_DISPLAY = "—"

function isUnsetValue(value) {
  if (value == null || value === "") {
    return true
  }
  const s = String(value).trim()
  return s === "" || s === RECRUIT_PROFILE_UNSET_DISPLAY
}

/**
 * Grid cell: label on top, value below (2-column layout parent).
 *
 * @param {object} props
 * @param {string} props.label
 * @param {string} props.value
 * @param {boolean} [props.fullWidth] Span both columns on sm+.
 * @param {boolean} [props.asChips] Render comma-separated values as chips.
 */
export default function RecruitProfileDisplayField({
  label,
  value,
  fullWidth = false,
  asChips = false,
}) {
  const theme = useTheme()
  const empty = isUnsetValue(value)
  const displayValue = empty ? RECRUIT_PROFILE_UNSET_DISPLAY : String(value)
  const chipParts =
    asChips && !empty
      ? displayValue
          .split(",")
          .map((part) => part.trim())
          .filter(Boolean)
      : []

  return (
    <Box
      sx={{
        ...recruitProfileDisplayFieldSx(theme, { empty }),
        gridColumn: fullWidth ? { xs: "1 / -1", sm: "1 / -1" } : undefined,
      }}
    >
      <Typography
        component="span"
        variant="body2"
        color="text.secondary"
        sx={{ fontWeight: 600, lineHeight: 1.4 }}
      >
        {label}
      </Typography>
      {asChips && chipParts.length > 0 ? (
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.75, mt: 0.25 }}>
          {chipParts.map((part) => (
            <Chip
              key={part}
              label={part}
              size="small"
              variant="outlined"
              sx={{
                height: 26,
                fontWeight: 500,
                borderColor: theme.palette.colors?.brand200 ?? "divider",
                bgcolor: "background.paper",
              }}
            />
          ))}
        </Box>
      ) : (
        <Typography
          variant="body2"
          sx={{
            mt: 0.25,
            fontWeight: empty ? 400 : 500,
            color: empty ? "text.disabled" : "text.primary",
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            lineHeight: 1.5,
          }}
        >
          {displayValue}
        </Typography>
      )}
    </Box>
  )
}
